import { MutationFn } from '@percent/workplace-giving/common/hooks/useMutation/useMutation.types'
import { ForgotPasswordProps, ForgotPasswordResponse } from './forgotPassword.types'

export const forgotPassword: MutationFn<ForgotPasswordProps, ForgotPasswordResponse> = (
  client,
  { email, captchaHeaders = {} }
) => {
  return client.post(
    `v1/auth/forgot-password`,
    {
      email,
      accountType: 'partner'
    },
    { headers: captchaHeaders }
  )
}
